// This component supports both User and Company Investors
//
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardTagLine from './CardTagLine';
import Avatar from './Avatar';

export default class InvestorCard extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    location: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    tags: PropTypes.array,
    maxTags: PropTypes.number,
    label: PropTypes.string.isRequired,
    avatarType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    maxTags: 4,
    location: null,
    description: null,
    avatar: null,
    tags: [],
    label: 'Investor',
    avatar_type: 'user',
  };

  render() {
    // Didn't manage to do this using a tailwind class because it got
    // overriden by the .Avatar class
    const avatarStyle = {};
    if (this.props.avatarType === 'company') {
      avatarStyle.borderRadius = 0;
    }

    return (
      <div
        className="Card-v2 Card-v2-padding"
        data-card-type={'Investor'}
        data-card-title={this.props.name}>
        <div className="u-flex u-items-stretch">
          <Avatar
            src={this.props.avatar}
            href={this.props.url}
            name={this.props.name}
            type={this.props.avatarType}
            className="u-w-16 md:u-w-36 u-h-16 md:u-h-36 u-text-4xl u-rounded Avatar--thin-initials"
            style={avatarStyle}
          />
          <div className="u-flex-1 u-flex u-flex-col u-pl-4">
            <div className="u-flex-1">
              <h5 className="u-text-lg u-m-0 u-leading-none">
                <a href={this.props.url}>{this.props.name}</a>
              </h5>
              <div className="u-text-grey u-text-sm u-mt-1 u-leading-normal">
                <span style={{ color: '#00AF6B' }}>{this.props.label}</span>
                {this.props.location && ` in ${this.props.location}`}
              </div>
              <div className="u-mt-1 u-mb-2">{this.props.description}</div>
            </div>
            <div className="u-flex-grow-0 md:u-block">
              {this.props.tags.length > 0 && (
                <CardTagLine
                  seeMoreURL={this.props.url}
                  tags={this.props.tags}
                  maxTags={this.props.maxTags}
                  keyIdentifier={this.props.name}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
